import type { Observable } from 'rxjs';
import type { HttpDataResponse } from '@common/types/http-response.type';
import type { SiteContent } from '@common/types/site-content.type';

import { Injectable } from '@angular/core';
import { shareReplay } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseHttpService } from '@common/services/REST/base.http.service';

@Injectable({
    providedIn: 'root',
})
export class ContentHttpService extends BaseHttpService {
    public getSiteContent(siteId: string | number): Observable<SiteContent> {
        return this.http
            .get<HttpDataResponse<SiteContent>>(this.formatApiUrl(`sites/${siteId}/content`))
            .pipe(map((res) => res.data));
    }

    public getSitePageContent(siteId: string | number, pageId: string | number): Observable<SiteContent> {
        return this.http
            .get<HttpDataResponse<SiteContent>>(this.formatApiUrl(`sites/${siteId}/pages/${pageId}/content`))
            .pipe(map((res) => res.data));
    }
}
